import axiosInstance from "src/common/axiosInstance";

const BASE_URL = "/admin/pipelines";

// Triggers a custom window event to click/fire the refresh button action automatically
const triggerAutoRefresh = () => {
    window.dispatchEvent(new Event("workflow:refresh"));
};

const workflowService = {
    /*
    |--------------------------------------------------------------------------
    | Workflow
    |--------------------------------------------------------------------------
    */

    async getWorkflow(pipelineId) {
        const resolvedPipelineId = pipelineId || localStorage.getItem("selectedPipelineId");
        if (!resolvedPipelineId) return;
        const response = await axiosInstance.get(`${BASE_URL}/workflow`, {
            params: { pipeline_id: resolvedPipelineId },
        });
        return response.data;
    },

    /*
    |--------------------------------------------------------------------------
    | Stages
    |--------------------------------------------------------------------------
    */

    async createStage(payload) {
        const response = await axiosInstance.post(
            `${BASE_URL}/stages`,
            payload
        );
        triggerAutoRefresh();
        return response.data;
    },

    async updateStage(stageId, payload) {
        const response = await axiosInstance.put(
            `${BASE_URL}/stages/${stageId}`,
            payload
        );
        triggerAutoRefresh();
        return response.data;
    },

    async deleteStage(stageId) {
        const response = await axiosInstance.delete(
            `${BASE_URL}/stages/${stageId}`
        );
        triggerAutoRefresh();
        return response.data;
    },

    async reorderStages(pipelineId, stages) {
        const response = await axiosInstance.put(
            `${BASE_URL}/stages/reorder`,
            {
                pipeline_id: pipelineId,
                stages,
            }
        );
        triggerAutoRefresh();
        return response.data;
    },

    /*
    |--------------------------------------------------------------------------
    | Nodes
    |--------------------------------------------------------------------------
    */

    async createNode(payload, { refresh = true } = {}) {
        const response = await axiosInstance.post(
            `${BASE_URL}/nodes`,
            payload
        );
        if (refresh) triggerAutoRefresh();
        return response.data;
    },

    async updateNode(nodeId, payload) {
        const response = await axiosInstance.put(
            `${BASE_URL}/nodes/${nodeId}`,
            payload
        );
        triggerAutoRefresh();
        return response.data;
    },

    async deleteNode(nodeId) {
        const response = await axiosInstance.delete(
            `${BASE_URL}/nodes/${nodeId}`
        );
        triggerAutoRefresh();
        return response.data;
    },

    async reorderNodes(nodes) {
        const response = await axiosInstance.put(
            `${BASE_URL}/nodes/reorder`,
            nodes
        );
        triggerAutoRefresh();
        return response.data;
    },

    /*
    |--------------------------------------------------------------------------
    | Transitions
    |--------------------------------------------------------------------------
    */

    async createTransition(payload) {
        const response = await axiosInstance.post(
            `${BASE_URL}/transitions`,
            payload
        );
        triggerAutoRefresh();
        return response.data;
    },

    async updateTransition(transitionId, payload) {
        const response = await axiosInstance.put(
            `${BASE_URL}/transitions/${transitionId}`,
            payload
        );
        triggerAutoRefresh();
        return response.data;
    },

    async deleteTransition(transitionId) {
        const response = await axiosInstance.delete(
            `${BASE_URL}/transitions/${transitionId}`
        );
        triggerAutoRefresh();
        return response.data;
    },
};

export default workflowService;
